import { route } from "@circle-react/lib/routes/define";

const SORTABLE_STRING_FIELD = {
  type: "string",
  description: "asc or desc",
} as const;

export const coursesRoutes = {
  overview: route("/settings/courses/overview", {
    title: "Courses overview",
    requires: "admin",
    description:
      "Courses settings overview — entry point into course and lesson management.",
  }),

  list: route("/settings/courses", {
    title: "Courses",
    requires: "admin",
    description:
      "Browse, filter, and manage all courses in the community. Supports pagination, status filtering, name search, and column sorting.",
    queryParams: {
      page: {
        type: "number",
        description: "Pagination page number (1-indexed).",
      },
      status: {
        type: "string",
        description:
          "Filter by course status (e.g. 'all', 'published', 'draft'). When omitted, all statuses are shown.",
      },
      query: {
        type: "string",
        description: "Filter by course name (partial match).",
      },
      course_type: {
        type: "string",
        description:
          "Filter by course type. Comma-separated values supported. Valid values: 'self_paced', 'scheduled'.",
      },
      order: {
        type: "object",
        description:
          "Sort order as nested params, e.g. order[name]=asc. Valid columns: 'name', 'students_count', 'lessons_count', 'created_at', 'course_type'. Direction: 'asc' or 'desc'.",
        properties: {
          name: SORTABLE_STRING_FIELD,
          students_count: SORTABLE_STRING_FIELD,
          lessons_count: SORTABLE_STRING_FIELD,
          created_at: SORTABLE_STRING_FIELD,
          course_type: SORTABLE_STRING_FIELD,
        },
      },
    },
  }),
  edit: route("/settings/courses/:id/edit", {
    title: "Edit course",
    requires: "admin",
    description: "Edit a specific course by its ID.",
    pathParams: {
      id: {
        type: "number",
        description: "Numeric identifier of the course to edit.",
      },
    },
    queryParams: {
      tab: {
        type: "string",
        description:
          "Tab to display on course edit page. Possible values are: 'overview', 'lessons', 'customize', 'paywalls', 'lock_screen', 'members', 'options', and 'workflows'.",
      },
      scrollToId: {
        type: "string",
        description: "Element ID to scroll to when the page loads.",
      },
    },
  }),
};
